module.exports = __webpack_public_path__ + "static/terry-crews-d8a12661a2438f9877266617025f0408.jpg";